


import { Box,Container } from "@mui/material";
const ParentWrapper = ({ children, sx }) => {



  return (
    <Box
      sx={{
        p: 3,
        ...sx,
        transition: (theme) =>
        theme.transitions.create("margin", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.shortest,
        }),
        backgroundColor: "#FEFEFE",
        minHeight: "100vh",
        gap: 3,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {children}
      
    </Box>
  );
};

export default ParentWrapper;



